import Swal from "sweetalert2";
import Vue from 'vue'
import {utils} from "./utils";
import {responses} from "./responses";
import {errorHandler} from "./errorHandler";
import queryStringify from "qs-stringify";
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import axios from "axios";
import copy from 'copy-to-clipboard';
import {dateTimeManager} from "@/Services/TimeManager";


window.copy = copy;
Vue.use(VueGoodTablePlugin);
Vue.prototype.$dateTimeManager = dateTimeManager;

window.serverApi = `https://overflow.pos.co.zm/OnlineSalesServer/`
// window.serverApi = `http://localhost:8282/OnlineSalesServer/`

window.OnlineserverApi = serverApi
window.franchiseApi = `https://chrilantech.com/LytSoftPosOnline/api/`
window.OnlineSalesServerTest = serverApi + `invoice/`
//  window.franchiseApi = `http://192.168.1.170:8080/print-api/v3/`

window.regApi = `https://chrilantech.com/regmac/api/`
//  window.franchiseApi = `http://127.0.0.1:8000/api/`
window.serverapi2 = serverApi

window.loyaltyApi = `https://overflow.pos.co.zm/loyalty_service/loyalty/`
// window.loyaltyApi = `http://192.168.1.124:8080/loyalty_service/loyalty/`

window.onlineSalesTomcatApi = serverApi

window.gateWayApi = `https://lna.pos.co.zm/KazangPaymentGateway/GateWay/`
// window.gateWayApi = `http://192.168.1.225:9333/KazangPaymentGateway/api/GateWay/`
window.stocklistApi2 = 'https://overflow.pos.co.zm/FranchiseSpringServer/'
 // window.stocklistApi2 = 'http://mcc:8282/FranchiseSpringServer/'

window.stocklistApi = 'https://overflow.pos.co.zm/Franchise_OnlineServer/'
//window.stocklistApi = 'http://self:8080/Franchise_OnlineServer/'
window.stocklistApi3 = stocklistApi
// window.stocklistApi ='http://localhost:8181/FranchiseSpringServer/'

 // window.franchiseTomcatApi35 = 'http://192.168.1.169:8080/Franchise_OnlineServer/'
//window.franchiseTomcatApi = 'http://self:8080/Franchise_OnlineServer/'
window.franchiseTomcatApi = `https://overflow.pos.co.zm/Franchise_OnlineServer/`
 // window.franchiseTomcatApi = `http://localhost:8282/Franchise_OnlineServer/`
window.franchiseTomcatApi2 =  franchiseTomcatApi;
 window.franchiseTomcatApi35 = franchiseTomcatApi;

// window.franchiseTomcatApi= franchiseTomcatApi2 ;


window.subscriptionApi = `https://overflow.pos.co.zm/SubscriptionManager/api/`
// window.subscriptionApi = `http://vincent:8080/SubscriptionManager/api/`

window.pettyCashApi = `https://lna.pos.co.zm/PettyCashApi/api/v1/`
// window.pettyCashApi = `http://192.168.1.221:8080/PettyCashApi/api/v1/`

window.StockTemplateApi = `https://chrilantech.com/LytSoftPosOnline/api/`

window.Storesapi = `https://lna.pos.co.zm/TicketApp/`
// window.Storesapi = `http://kabs:8080/TicketApp/`
// window.Storesapi = `https://lna.pos.co.zm/TicketApp/`

//window.backoffice = `http://192.168.1.221:8080/Lyt-SoftBackOfficeApi/`
//window.backOfficeTomcatApi =  `http://self:8080/Lyt-SoftBackOfficeApi/`
window.backOfficeTomcatApi =  `https://overflow.pos.co.zm/Lyt-SoftBackOfficeApi/`
window.backoffice = backOfficeTomcatApi;

window.analyticss = `https://overflow.pos.co.zm/`
// window.backOfficeTomcatApi = `http://192.168.1.216:8080/backoffice/`
window.Labelapi = backOfficeTomcatApi;

window.dsrApi = `https://dsr.pos.co.zm`;


// lyt-sofyt-rush
// window.lytSoftRushApi = `http://localhost:8282/BulkInvoice/api/v1/`
window.lytSoftRushApi = 'https://overflow.pos.co.zm/BulkInvoice/api/v1/'

window.DeliveryNote = backOfficeTomcatApi;

window.ticketApi = `https://lna.pos.co.zm/TicketApp/`
// window.ticketApi = `http://kabs:8086/TicketApp/`
// window.ticketApi2 = `http://192.168.1.177:8086/TicketApp/`

window.Safesapi = backOfficeTomcatApi;

window.gateway = `https://lna.pos.co.zm/KazangPaymentGateway/`

window.synergyApi = `https://lna.pos.co.zm/SynergyApi/api/v1/`
// window.synergyApi = `http://vincent:8080/SynergyApi/api/v1/`

window.subscriptionTomcatApi = `https://overflow.pos.co.zm/SubscriptionManager/api/`
// window.subscriptionTomcatApi = `http://mcc:8282/SubscriptionManager/api/`
window.subscriptionTomcatApiforMainId = `https://overflow.pos.co.zm/SubscriptionManager/api/`
// window.subscriptionTomcatApi = `http://localhost:8080/subscription/api/`
window.customerPanelApi = subscriptionTomcatApi + `adminCustomerPanel/`

// Global connectivity probe URL used by NetworkStatus component; not an app API
window.connectivityProbe = `https://dns.google/`

// window.printApi = `https://tom9.pos.co.zm/PrintApi/`
window.printApi = `https://overflow.pos.co.zm/PrintApi/`
 // window.printApi = `http://192.168.1.208:8282/PrintApi/`



window.analyticsDocApi = `https://overflow.pos.co.zm/AnalyticsDocuments/api/v1/`
// window.analyticsDocApi = `http://localhost:8282/AnalyticsDocs/api/v1/`

// Lyt-Soft SAP Adapter base URL (per guidelines: use global, never hardcode in components)
// window.sapAdapterApi = `http://192.168.1.151:6005/lytsapapi/`
window.sapAdapterApi = `https://lna.pos.co.zm/lytsapapi/`

// window.hardwareApi = `http://192.168.1.140:9090/`;
window.hardwareApi = `http://localhost:9090/`;

window.responses = responses;
window.errorHandler = errorHandler

const EventBus = new Vue()
window.EventBus = EventBus

// window.log = (val) => console.log(val);
window.Swal = Swal;

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}

Vue.prototype.$utils = utils;
window.$utils = utils;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;
window.axios = axios;
window.stringify = (object) => queryStringify(object);
window.openUrl = (url, target = '_blank') => window.open(url, target, "_blank");
window.getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
window.pageOptions = {
    enabled: true,
    mode: 'pages',
    perPage: 10,
    position: 'bottom',
    perPageDropdown: [10, 100, 200],
    dropdownAllowAll: false,
    jumpFirstOrLast: true,
    pageLabel: 'page', // for 'pages' mode
}

window.isValidString = (string) => {
    if (!string) return false;
    string = string.toString().trim();
    return !(string === `null` || string === `undefined` || string === ``);

}

window.stripMimeType = (base64) => {
    const pattern = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,/;
    return base64.replace(pattern, '');
}

 window.ticketApi = `https://lna.pos.co.zm/TicketApp/`
// window.ticketApi = `http://mcc:8282/TicketApp/`
